import { useCallback, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { toast } from '@sales-center/components'
import { FM_FORM_STATUSES } from '@user/store/agreements/typings'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { removeLeadFromList } from '@user/store/lead'

export function useLeadAutoCloseSignedFlow(
  entityId: number,
  active: boolean,
  onAutoClosed?: () => void,
) {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const signedRef = useRef(false)

  const onFormStatusChange = useCallback(
    (status: FM_FORM_STATUSES | undefined) => {
      if (
        status === FM_FORM_STATUSES.Signed ||
        status === FM_FORM_STATUSES.Complete
      ) {
        signedRef.current = true

        if (active) {
          toast.success('Lead was automatically closed/won.')
        }
      }
    },
    [active],
  )

  const handleFormManagerClosed = useCallback(() => {
    if (!active || !signedRef.current) return
    signedRef.current = false

    // The lead record won't exist once converted — leave its detail page
    if (location.pathname === `/leads/${entityId}`) {
      navigate('/leads')
    }

    // Drop the converted lead from the card list optimistically — no refetch
    dispatch(removeLeadFromList(entityId))

    // Surface-specific cleanup (map view closes its drawer and reloads pins)
    onAutoClosed?.()
  }, [active, dispatch, navigate, location.pathname, entityId, onAutoClosed])

  return { onFormStatusChange, handleFormManagerClosed }
}
